import { number, object } from "yup";

export const actionValidationSchema = object({
  meta: object({
    delai: number()
      .required(" ")
      .min(0, "Le nombre doit être entre 0 et 28")
      .max(28, "Le nombre doit être entre 0 et 28"),
  }).required(),
});

export const actionIV = {
  meta: { delai: "" },
};
